import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { styles } from "../../config/config.theme";
// styled MUI button
export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: styles["background-secondary"],
  border: `1px solid ${styles["text-primary"]}`,
  color: styles["text-primary"],
  "&:hover": {
    backgroundColor: styles["background-primary"],
    border: `1px solid ${styles["background-tertiary"]}`,
    color: styles["text-primary"],
  },
}));
